import { createSlice } from "@reduxjs/toolkit";
import { current } from "@reduxjs/toolkit";
import { getFailedProductListData } from "../../utils/plp/common";

const initialState = {
  details: {},
  appliedFilters: [],
  appliedSort: {},
  requestToProductListingDetails: false,
  responseFromProductListingDetails: false,
  failedToProductListingDetails: false,
  isLoaded: false,
  error: null,
  loadedVideoIds: {},
  currentVideoId: null,
  sortBy: "",
  sortOrder: "",
  isFilterOpen: false,
  isSortOpen: false,
  clickedFilterChip: "",
};

export const PLPSlice = createSlice({
  name: "ProductListing",
  initialState,
  reducers: {
    requestToFetchProductListingAction: (state) => {
      return {
        ...state,
        requestToProductListingDetails: true,
        isLoaded: false,
      };
    },
    requestToFetchProductFilterInMobile: (state) => {
      return {
        ...state,
      };
    },
    setProductListingFilterForMobile: (state, action) => {
      return {
        ...state,
        mobileFilterDetail: action.payload,
      };
    },
    responseFromFetchProductListingAction: (state, action) => {
      return {
        ...state,
        responseFromProductListingDetails: true,
        details: {
          ...action.payload.response,
        },
        appliedFilters: action.payload.filters || [],
        appliedSort: action.payload.sortOption || {},
        isLoaded: true,
      };
    },
    responseFromLoadMoreProductListingAction: (state, action) => {
      return {
        ...state,
        responseFromProductListingDetails: true,
        details: {
          ...action.payload,
          data: [...(current(state?.details)?.data || []), ...action.payload.data],
        },
        isLoaded: true,
      };
    },
    responseFromClearFiltersAction: (state, action) => {
      return {
        ...state,
        appliedSort: { ...state.appliedSort },
        appliedFilters: action.payload.filters,
        isLoaded: true,
      };
    },
    requestToAddListingDataAction: (state) => {
      return {
        ...state,
        isLoaded: false,
      };
    },
    responseFromAddListingDataAction: (state, action) => {
      return {
        ...state,
        details: action.payload.details,
        appliedFilters: action.payload.filters || [],
        appliedSort: action.payload.sortOption || {},
        isLoaded: true,
      };
    },
    failedToFetchProductListingAction: (state, action) => {
      return {
        ...state,
        details: {
          ...action.payload.response,
          data: getFailedProductListData(state, action.payload.response),
        },
        failedToProductListingDetails: true,
        error: action.payload,
        isLoaded: true,
      };
    },
    setLoadedVideoIds: (state, action) => {
      return {
        ...state,
        loadedVideoIds: {
          ...state.loadedVideoIds,
          ...action.payload,
        },
      };
    },
    setCurrentVideoId: (state, action) => {
      return {
        ...state,
        currentVideoId: action.payload,
      };
    },
    setClickedFilterChip: (state, action) => {
      return {
        ...state,
        clickedFilterChip: action.payload,
      };
    },
    setIsFilterOpen: (state, action) => {
      return {
        ...state,
        isFilterOpen: action.payload,
      };
    },
    setIsSortOpen: (state, action) => {
      return {
        ...state,
        isSortOpen: action.payload,
      };
    },
  },
});

export default PLPSlice.reducer;
export const {
  failedToFetchProductListingAction,
  requestToFetchProductListingAction,
  responseFromFetchProductListingAction,
  responseFromLoadMoreProductListingAction,
  responseFromClearFiltersAction,
  requestToAddListingDataAction,
  responseFromAddListingDataAction,
  setLoadedVideoIds,
  setCurrentVideoId,
  requestToFetchProductFilterInMobile,
  setProductListingFilterForMobile,
  setClickedFilterChip,
  setIsFilterOpen,
  setIsSortOpen,
} = PLPSlice.actions;
